import { createStore, applyMiddleware, compose } from 'redux';
import reducer from '@/reducer';
// import devToolsEnhancer, { composeWithDevTools } from 'remote-redux-devtools';
// import withReduxEnhancer from 'addon-redux/enhancer';
// import throttledMiddleware from './util/throttled';

const composeEnhancers = 
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      latency: 50,
      maxAge: 500,
      trace: false
    }) : ()=>{}//composeWithDevTools;


//composeEnhancers()
const enhancers = composeEnhancers()
// devToolsEnhancer(
// {
//     hostname: 'localhost', port: 8000
//   }
// );
// (
//   applyMiddleware()
// );


const configureStore = (enhance) => {
  // console.log('CONFIGURE STORE!', 'with enhance', enhance);
  if (enhance) {
    return createStore(
      reducer, /* preloadedState, */ 
      enhancers
    )
  } else {
    return createStore(
      reducer, /* preloadedState, */ 
    )
  }

};

export default configureStore;

